import { LAST_SELECTED_TEACHER_CLASS_ID } from 'src/constants/local-storage.constants';

export const saveLastSelectedTeacherClassId = (classId: string) => {
  try {
    window.localStorage.setItem(LAST_SELECTED_TEACHER_CLASS_ID, classId);
  } catch (e) {
    console.error(`Failed to store last selected teacher class ID ${e}`);
  }
};

export const getLastSelectedTeacherClassId = () =>
  window.localStorage.getItem(LAST_SELECTED_TEACHER_CLASS_ID);
